"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerDatasetApiClient = createPartnerDatasetApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnerDatasetApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    const pathPartnerDataset = (partnerDatasetId) => {
        if (partnerDatasetId) {
            return `/v1/dataset/partners/${partnerDatasetId}`;
        }
        else {
            return `/v1/dataset/partners`;
        }
    };
    async function getPartnerDataset(params) {
        try {
            const response = await client.get(pathPartnerDataset(params.partnerDatasetId));
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function createPartnerDataset(data) {
        try {
            const response = await client.post(pathPartnerDataset(), data);
            const location = response.headers.location || '';
            return location.replace('/v1/dataset/partners/', '');
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function deletePartnerDataset(params) {
        try {
            await client.delete(pathPartnerDataset(params.partnerDatasetId));
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function deleteUser(request, options) {
        try {
            return await client.post('v1/dataset/delete-user-request', request, { params: options });
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getPartnerDataset,
        deletePartnerDataset,
        createPartnerDataset,
        deleteUser
    };
}
//# sourceMappingURL=data:application/json;base64,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